import script from "./CardRive.vue?vue&type=script&setup=true&lang=js"
export * from "./CardRive.vue?vue&type=script&setup=true&lang=js"

import "./CardRive.vue?vue&type=style&index=0&id=37d4f738&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d4f738"]])

export default __exports__